export { default as ProductsTypesFilterBadge } from './ProductsTypesFilterBadge';
